import React, { useState } from "react";
import { Box, Container, Paper, Tabs, Tab } from "@mui/material";
import NewImages from './NewImages';
import InterestImages from './InterestImages';

const Special_images = () => {
  const [value, setValue] = useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <React.Fragment>
      <Container maxWidth="lg" sx={{ mt: 4, mb: 4 , backgroundColor: 'adminTheme.palette.background.default'}}>
        <Paper>
          <Tabs value={value} onChange={handleChange} indicatorColor="primary" textColor="primary">
            <Tab label="Add New Image" />
            <Tab label="Update Interest" />
          </Tabs>
        </Paper>
        <Paper sx={{ mt: 2 }}>
          <Box p={3}>
            {value === 0 && <NewImages />}
            {value === 1 && <InterestImages />}
          </Box>
        </Paper>
      </Container>
    </React.Fragment>
  );
};

export default Special_images;

